import { activeOrgSelector } from 'redux/reducer/AuthenticationReducer';
import { axiosInstance } from 'utils/http';
import { flow } from 'utils/urlConstants';
import { showAlert } from 'redux/actions/AlertActions';
import { useDispatch, useSelector } from 'react-redux';
import { useQuery } from 'react-query';


export const useFetchCleanRoomFlowRuns = ({ crFlowId, crId }) => {
  const { ID: orgId } = useSelector(activeOrgSelector);
  const dispatch = useDispatch();
  const {
    isLoading, isError, isSuccess, data,
  } = useQuery(
    ['Cr-Flow-Runs', crFlowId, orgId],
    async () => axiosInstance.get(flow(orgId).runList(crId, crFlowId)),
    {
      onSuccess: () => dispatch(showAlert({ message: 'Flow runs fetched successfully.', type: 'success' })),
      retry: false,
      refetchOnWindowFocus: false,
    },
  );

  return {
    isLoading, isError, isSuccess, data,
  };
};
